import { defaultPorts } from '@doss/common-all'

// When loaded in a WebView (emulator or physical device), localhost refers to the
// device itself, not the host machine. Use the hostname from the current URL so
// service requests reach the dev server on the host machine.
const getLocalHost = (): string => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return window.location.hostname
  }
  return String(import.meta.env['VITE_LOCAL_HOST_IP'] ?? 'localhost')
}

export const config = {
  apiBaseUrl: `${getLocalHost()}:${String(defaultPorts.api)}`,
  protocol: 'http',
  websocketProtocol: 'ws',
  isProduction: false,
  isStaging: false,
}
